import React from 'react'
import '../App.css'

function Reviews() {
  return (
    <div>
      
    </div>
  )
}

export default Reviews
